export default __webpack_public_path__ + "assets/wide-green-blackboard.jpg";